import 'twin.macro';

import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ThemeContext } from '@/contexts/theme-context';
import LandingPrepaidBanner from '@/views/landing-prepaid/landing-prepaid-banner';
import LandingPrepaidConditions from '@/views/landing-prepaid/landing-prepaid-conditions';
import LandingPrepaidHowWorks from '@/views/landing-prepaid/landing-prepaid-how-works';
import LandingPrepaidQA from '@/views/landing-prepaid/landing-prepaid-qa';

function LandingPrepaid() {
  const { theme, setTheme } = useContext(ThemeContext);
  const location = useLocation().pathname;

  useEffect(() => {
    setTheme('dark');
  }, [setTheme]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <LandingPrepaidBanner />
      <LandingPrepaidHowWorks />
      <LandingPrepaidConditions />
      <LandingPrepaidQA />
    </>
  );
}

export default LandingPrepaid;
